<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-8 bg-gradient-success">
      <div class="d-flex align-items-center justify-content-between mb-3 mt-3">
        <b-button variant="secondary" class="ml-2" @click="$router.go(-1)">
          <i class="fas fa-arrow-left"></i> Volver
        </b-button>
        <div class="d-flex" style="gap:8px;">
          <b-button v-if="editMode && puedeEditar" @click.prevent="submitForm" variant="primary">
            <i class="fas fa-save mr-1"></i> Guardar
          </b-button>
          <!-- Sin permiso de edición la pantalla queda en modo consulta. -->
          <base-button v-if="puedeEditar" :type="editMode ? 'danger' : 'warning'" @click="cancelEdit">
            {{ editMode ? 'Cancelar' : 'Editar' }}
          </base-button>
        </div>
      </div>

      <b-container style="max-width: 90%; margin: auto;">

        <b-card-header class="border-0">
          <h3 class="mb-0">Información</h3>
        </b-card-header>
        <b-form @submit.prevent="submitForm">
          <b-row>
            <b-col md="3">
              <b-form-group label-for="clase">
                <template v-slot:label>
                  Clase <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="clase" v-model="form.clase" required
                  placeholder="Clase"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="segmento">
                <template v-slot:label>
                  Segmento <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="segmento" v-model="form.segmento" required
                  placeholder="Segmento"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="familia">
                <template v-slot:label>
                  Familia <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="familia" v-model="form.familia" required
                  placeholder="Familia"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="categoria">
                <template v-slot:label>
                  Categoría <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="categoria" v-model="form.categoria" required
                  placeholder="Categoría"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label-for="claseIngles">
                <template v-slot:label>
                  Clase (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="claseIngles" v-model="form.claseIngles" required
                  placeholder="Clase (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="segmentoIngles">
                <template v-slot:label>
                  Segmento (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="segmentoIngles" v-model="form.segmentoIngles" required
                  placeholder="Segmento (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="familiaIngles">
                <template v-slot:label>
                  Familia (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="familiaIngles" v-model="form.familiaIngles" required
                  placeholder="Familia (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="categoriaIngles">
                <template v-slot:label>
                  Categoría (inglés) <span class="text-danger">*</span>
                </template>
                <b-form-input :disabled="!editMode" id="categoriaIngles" v-model="form.categoriaIngles" required
                  placeholder="Categoría (inglés)"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label-for="accion" label="Acción">
                <b-form-input :disabled="!editMode" id="accion" v-model="form.accion"
                  placeholder="Acción"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="version" label="Versión">
                <b-form-input :disabled="!editMode" id="version" v-model="form.version"
                  placeholder="Versión"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label-for="actualizacion" label="Actualización">
                <b-form-input :disabled="!editMode" id="actualizacion" v-model="form.actualizacion"
                  placeholder="Actualización"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button v-if="editMode && puedeEditar" type="submit" variant="primary" class="ml-3">
            Guardar
          </b-button>
        </b-form>
      </b-container>
    </base-header>
  </div>
</template>

<script>
import taxonomiaService from '@/api/taxonomiaService';
import utilsService from '@/api/utilsService';
import Swal from 'sweetalert2';

export default {
  name: 'TaxonomiaDetalle',
  computed: {
    puedeEditar() {
      return utilsService.puedeEscribir() && utilsService.getRol() !== 'ventas inex';
    },
  },
  data() {
    return {
      form: {
        segmento: '',
        familia: '',
        categoria: '',
        clase: '',
        version: '',
        segmentoIngles: '',
        familiaIngles: '',
        categoriaIngles: '',
        claseIngles: '',
        accion: '',
        actualizacion: '',
      },
      originalKey: {
        segmento: '',
        familia: '',
        categoria: '',
        clase: '',
      },
      editMode: false,
    };
  },
  async beforeMount() {
    this.$store.dispatch('setSidebarCollapsed', false);
    const q = this.$route.query;
    this.originalKey = {
      segmento: q.segmento || '',
      familia: q.familia || '',
      categoria: q.categoria || '',
      clase: q.clase || '',
    };
    await this.cargarTaxonomia();
  },
  methods: {
    encontrarItem(lista) {
      const k = this.originalKey;
      return (lista || []).find(t =>
        String(t.segmento) === String(k.segmento) &&
        String(t.familia) === String(k.familia) &&
        String(t.categoria) === String(k.categoria) &&
        String(t.clase) === String(k.clase)
      );
    },

    async cargarTaxonomia() {
      try {
        const lista = await taxonomiaService.getAll();
        const item = this.encontrarItem(lista);
        if (!item) {
          Swal.fire({ icon: 'error', title: 'Oops...', text: 'No se encontró la taxonomía.' });
          this.$router.push({ name: 'taxonomias' });
          return;
        }
        this.form = {
          segmento: item.segmento || '',
          familia: item.familia || '',
          categoria: item.categoria || '',
          clase: item.clase || '',
          version: item.version || '',
          segmentoIngles: item.segmentoIngles || '',
          familiaIngles: item.familiaIngles || '',
          categoriaIngles: item.categoriaIngles || '',
          claseIngles: item.claseIngles || '',
          accion: item.accion || '',
          actualizacion: item.actualizacion || '',
        };
      } catch (error) {
        Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error al cargar la taxonomía.' });
        this.$router.push({ name: 'taxonomias' });
      }
    },

    async cancelEdit() {
      if (this.editMode) {
        await this.cargarTaxonomia();
      }
      this.editMode = !this.editMode;
    },

    submitForm() {
      if (!this.puedeEditar) return;
      Swal.fire({
        title: '¿Está seguro?',
        text: 'Revisa los datos antes de continuar.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            Swal.fire({
              html: '<div style="display:flex;align-items:center;justify-content:center;">' +
                    '<img src="/img/others/loading.gif" alt="Loading" style="width:50px;height:50px;margin-right:15px;">' +
                    '<div><h3 style="color:#006393;">Actualizando...</h3></div>' +
                    '</div>',
              showConfirmButton: false,
              allowOutsideClick: false,
            });
            const response = await taxonomiaService.update(this.originalKey, this.form);
            if (!response) {
              Swal.fire({ icon: 'error', title: 'Oops...', text: 'Ocurrió un error inesperado.' });
              return;
            }

            Swal.fire({
              title: 'Actualizado correctamente',
              icon: 'success',
              showConfirmButton: false,
              timer: 2000,
            });
            this.originalKey = {
              segmento: this.form.segmento,
              familia: this.form.familia,
              categoria: this.form.categoria,
              clase: this.form.clase,
            };
            this.editMode = false;
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: (error && error.message) ? error.message : 'Ocurrió un error inesperado.',
            });
          }
        } else if (result.isDenied) {
          Swal.close();
        }
      });
    },
  },
};
</script>
